<app-resp-popup-title>
  <mat-icon>folder</mat-icon>
  <span>&nbsp;</span>
  <span i18n="Vorgang bearbeiten@@Infoportal_AddFolder_Title">
    Create a new Folder
  </span>
</app-resp-popup-title>
<app-resp-popup-content>
  <div style="width: 500px; max-width: 100%; position: relative">
    @if (form) {
      <form [formGroup]="form">
        <fieldset>
          <div class="row">
            <div class="col">
              <frm-text
                i18n-label="@@Infoportal_AddFolder_Description"
                label="Description"
                formControlName="bezeichnung"
                >
              </frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-text
                multiline="true"
                rows="5"
                formControlName="info"
                i18n-label="@@Infoportal_AddFolder_Info"
                label="Info"
                >
              </frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-infoportal-tags-select
                formControlName="tagIDs"
              ></frm-infoportal-tags-select>
            </div>
          </div>
        </fieldset>
      </form>
    }
  </div>
</app-resp-popup-content>
<app-resp-popup-actions>
  <ctrl-btn-accept
    [disabled]="loading || !form.valid"
    (click)="onAccept()"
  ></ctrl-btn-accept>
  <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
</app-resp-popup-actions>

<ng-template #shimmer>
  <app-shimmer [isLoading]="true" type="custom">
    <ng-template shimmerPreviewTemplate>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input height="170px"></app-shimmer-input>
    </ng-template>
  </app-shimmer>
</ng-template>
